import { Fade, FadeProps, Grow, GrowProps, Slide, SlideProps, Zoom, ZoomProps } from "@mui/material";
import React from "react";
export const WcFade = ( {...props }: FadeProps) => (
    <Fade  {...props} />
  );
  

  export const WcGrow = ( {...props }: GrowProps) => (
    <Grow  {...props} />
  );
  

  export const WcSlide = ( {...props }: SlideProps) => (
    <Slide  {...props} />
  );

  export const WcZoom = ( {...props }: ZoomProps) => (
    <Zoom  {...props} />
  );
  
